module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "preview"
  }, [_c('div', {
    ref: "preview",
    staticClass: "preview-area"
  }, _vm._l((_vm.components), function(item, index) {
    return (!item.parentId) ? _c('div', {
      attrs: {
        "id": item.info.id
      }
    }) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af997ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_product.vue
// module id = 548
// module chunks = 1